import React from 'react'
import { toolsAPI } from '../../utils/funcionesAPI'
import {manejadorDeRespuesta} from '../../utils/Tools'
import {RUTA_IMAGEN} from '../../utils/rutasFijas';

class BuscadorAgencias extends React.Component {

  constructor(props) {
      super(props)

      this.state = {zonas : [], agencias: [], codigoZonaSeleccionado: 'CAPITAL'};

      this.handleComboZonaChange = this.handleComboZonaChange.bind(this);
  }



  componentDidMount() {

    window.scrollTo(0,0);
    this.traerZonas();
    this.traerAgencias(this.state.codigoZonaSeleccionado);
  }

  traerZonas() {
      const _this = this;
      let data = JSON.stringify({accion: 'traerZonas'});
      toolsAPI(data)
              .then(respuesta => {
                if(manejadorDeRespuesta(this.props, respuesta)) {
                  _this.setState({zonas: respuesta.data});
                }



              });
  }

  traerAgencias(zona) {
      const _this = this;
      let data = JSON.stringify({accion: 'traerAgenciasWeb', zona: zona});
      toolsAPI(data)
              .then(respuesta => {
                if(manejadorDeRespuesta(this.props, respuesta)) {
                  _this.setState({agencias: respuesta.data});
                }

              });
  }

  handleComboZonaChange(e) {
      this.traerAgencias(e.target.value);
      this.setState({codigoZonaSeleccionado: e.target.value});
  }


  render() {


      return (
        <section className="sobre-pedraza">

          <div className="container">
            <div className="row">
              <article className="txt col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <h1>También podés contratar los productos Pedraza desde nuestras Agencias amigas</h1>
                <h3>Buscá la mas cercana a tu barrio</h3>
                <hr />
                <p>Buscador por Zona:
                    <select className="comboBuscarZona" name="zona" value={this.state.codigoZonaSeleccionado} onChange={this.handleComboZonaChange}>
                      {
                        this.state.zonas.map((zona) => {
                        return <option key={zona.idZona} value={zona.codigo}>{zona.denominacion}</option>
                        })
                      }
                    </select>
                </p>
                <div>
                {
                  this.state.agencias.length > 0 ?
                    this.state.agencias.map((agencia, index) => {
                    return <div key={index} className="caja_agencia col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12">
                              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 caja_agencia_logo">
                                <img src={`${RUTA_IMAGEN}agencias/${agencia.logo}`} alt="Agencia"  />
                              </div>
                              <div className="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9 caja_agencia_texto">
                                <p><strong>{agencia.denominacion}</strong></p>
                                <p>{agencia.direccion} - {agencia.localidad}</p>
                                <p>Tel.: {agencia.telefono}</p>
                                <p>Leg: {agencia.legajo}</p>
                              </div>
                            </div>
                    }) : <div>
                      <h5 style={{'marginTop':'40px'}}>Sin Agencias por el momento</h5>
                    </div>
                }
              </div>
              </article>
            </div>
          </div>
        </section>

      )

  }
}

export default BuscadorAgencias

/*
<div className="caja_agencia col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
  <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 caja_agencia_logo">
    <img src={RUTA_IMAGEN + 'agencias/turismopsl.png'} alt="Turismo PSL" width="60" />
  </div>
  <div className="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9 caja_agencia_texto">
    <h5>Turismo PSL</h5>
    <p>Dir: San Miguel</p>
    <p>Tel.: </p>
    <p>Leg: 1234 </p>
  </div>
</div>


*/



// WEBPACK FOOTER //
// ./src/components/Global/BuscadorAgencias.js